
import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TextInput from "../common/textfield/TextInput.jsx";
import '../apps/ResourcesHub/ResourceHub.css';
import { Col, Row, Table } from "react-bootstrap";
import { InputLabel, Skeleton, TableCell, Tooltip } from "@mui/material";
import CustomPagination from "../common/components/Pagination/CustomPagination.js";
import { getAuthorizedResources, getDocumentReference } from "../api/FillableDocument.js/index.js";
import { useFormik } from 'formik'
import { useClinicLocationsQuery } from "../../hooks/ReactQueryHooks/useClinicLocationsQuery.js";
import { ViewLocation } from "../apps/ResourcesHub/ViewLocation.js";
import { truncateText } from "../apps/ResourcesHub/constant.js";
import { getServiceLineById } from "../api/ServiceLine/index.js";


export function Resources({ show, onHide, serviceLineId, encounterOrgId}) {
    const [documentList, setDocumentList] = useState([]);
    const [filteredDocumentList, setFilteredDocumentList] = useState([]);
    const totalRows = filteredDocumentList.length;
    const [page, setPage] = useState(0);
    const rowsPerPage = 6;
    const [isLoading, setIsLoading] = useState(false);  
    const [locations, setLocations] = useState([]);
    const [viewlocationData, setViewlocationData] = useState(false);
    const [orgList, setOrgList] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState("All"); 
    const [serviceLineResources, setServiceLineResources] = useState([]);
    const [showSLResourcesOnly, setShowSLResourcesOnly] = useState(true);

    const onSuccessLocations = (data) => {
      setLocations(data);
    };
  
    
    const userOrganizationId = useSelector(
        (state) => state?.auth?.user?.["organizations"][0].id
    );

    useClinicLocationsQuery({ onSuccess: onSuccessLocations, orgIds: [userOrganizationId]});

    const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
    const tableTitle = ["Name", "Description", "Location"]

    const formik = useFormik({
            initialValues: {
                name: "",
            },
          onSubmit: (values) => {
              // Other form submission logic
          }
    });

    const sortAndFilter = (data) => {
        return data
            .filter(doc => doc.status === 'current')    
            .sort((a, b) => {
                let titleA = a?.content?.[0]?.attachment?.title;
                let titleB = b?.content?.[0]?.attachment?.title
                if (titleA < titleB) return -1;
                if (titleA > titleB) return 1;
                return 0;
        });
    };

    const getListOfDocument = async () => {
        setIsLoading(true);
        const res = await getAuthorizedResources();
        const sorted = sortAndFilter(res.result || []);
        setDocumentList(sorted);
        if(!showSLResourcesOnly && !serviceLineId)
            setFilteredDocumentList(sorted);
         
        const normalize = (s) => (s || "").normalize("NFKD").trim().toLowerCase();
        
        const uniques = Array.from(
            new Set(
            sorted
                .map((d) => d.custodian?.display)
                .filter((x) => typeof x === "string")
            )
        );
        
        const sortedOrgNames = uniques.sort((a, b) =>
            normalize(a).localeCompare(normalize(b), undefined, { numeric: true })
        );
        
        setOrgList(sortedOrgNames);
        setIsLoading(false);
    };

    const handleSearchChange = (e) => {
        const searchTerm = e.target.value.toLowerCase();
        formik.setFieldValue("name", searchTerm);

        if (showSLResourcesOnly) {
            const filtered = serviceLineResources.filter((doc) =>
                doc?.content?.[0]?.attachment?.title?.toLowerCase().includes(searchTerm)
            );
            setFilteredDocumentList(filtered);
        } else {
            const filtered = documentList.filter((doc) =>
                doc?.content?.[0]?.attachment?.title?.toLowerCase().includes(searchTerm)
            );
            setFilteredDocumentList(filtered);
        }

        setPage(0);
    };

    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setShowSLResourcesOnly(isChecked);

        // Clear the search input
        formik.setFieldValue("name", "");

        if (isChecked) {
            // Show service line resources (no filtering)
            setFilteredDocumentList(serviceLineResources);
        } else {
            // Show full list (unfiltered)
            setFilteredDocumentList(documentList);
        }

        setPage(0);
    };


    const handleLinkOpen = async(url) => {
        const fullUrl = url.startsWith("http") ? url : `https://${url}`;
        window.open(fullUrl, "_blank", "noopener,noreferrer");
    }

    const handleViewLocation = async (id) => {
        if(viewlocationData){
            setViewlocationData(false)
        }else{
            const clickedLocation = locations.filter(loc => loc.id === id)[0]
            setViewlocationData(clickedLocation)
        }
      }

    useEffect(() => {
        getListOfDocument();
    }, []);

    useEffect(() => {
        if (encounterOrgId && serviceLineId) {
            setIsLoading(true);
            getServiceLineById(encounterOrgId, serviceLineId).then((res) => {
                if (res?.status === true) {
                    // use the service line resource ids to get the 
                    // appropriate document references
                    let resources = res?.data?.resources;
                    let resourceIds = resources.map(item => item.id);
                    let extracted = documentList.filter((item) => resourceIds.includes(item.id))
                    setServiceLineResources(extracted);
                    if (showSLResourcesOnly) {
                        setFilteredDocumentList(extracted);
                    }
                }
                else setFilteredDocumentList(documentList)
                setIsLoading(false);
            });
        }
    }, [serviceLineId, encounterOrgId, documentList]);

    const applyFilters = (orgFilter, statusFilter, searchTerm) => {
        if (showSLResourcesOnly) {
            const filtered = serviceLineResources.filter((doc) =>
                doc?.content?.[0]?.attachment?.title?.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredDocumentList(filtered);
            return;
        }

        let filtered = documentList;

        if (searchTerm) {
            filtered = filtered.filter((d) =>
                d.content?.[0]?.attachment?.title
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            );
        }

        if (orgFilter && orgFilter !== "All") {
            filtered = filtered.filter((d) => d.custodian?.display === orgFilter);
        }

        if (statusFilter && statusFilter !== "All") {
            filtered = filtered.filter((d) =>
                statusFilter === "Active" ? d.status === "current" : d.status !== "current"
            );
        }

        setFilteredDocumentList(filtered);
        setPage(0);
    };


    const handleOrgChange = (e) => {
        const org = e.target.value;
        setSelectedOrg(org);
        applyFilters(org, "Active", formik.values.name);
    };    

    return (
        <>
        <ViewLocation modalShow={viewlocationData} handleShow={handleViewLocation}/> 
        <Modal
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            centered 
            onHide={onHide}
            backdropClassName
            backdrop={'static'}
            className="custom-dialog"
            dialogClassName="modal-90w"
        >
            <Modal.Header closeButton className="border-0">
                <Modal.Title id="contained-modal-title-vcenter">
                    Resources
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="common-form border-fields resourceHub">
                <Row>
                    <Col md={6}>
                        <TextInput
                            keyField={"name"}
                            formik={formik}
                            placeholder={"Search Resources"}
                            hideRequired={true}
                            onChange={handleSearchChange} 
                            value={formik.values.name} 
                        />
                    </Col>

                    <Col className="d-flex align-items-end">
                        <div style={{marginBottom: "35px"}}>
                            <input
                                type="checkbox"
                                checked={showSLResourcesOnly}
                                onChange={handleCheckboxChange}
                                id="sl-resource-toggle"
                            />
                            <label htmlFor="sl-resource-toggle" className="ms-2">
                                Service Line Attached Resources
                            </label>
                        </div>
                    </Col>

                    {!showSLResourcesOnly && <Col>
                        <div style={{marginBottom: "20px"}}><InputLabel>Select Organization</InputLabel>
                        <select
                            className="form-control"
                            value={selectedOrg}
                            onChange={handleOrgChange}
                        >
                        <option value="All">All</option>
                        {orgList.map((org) => (
                            <option key={org} value={org}>
                                {org}
                            </option>
                        ))}
                        </select></div>
                    </Col>}
                </Row>
                <div className="table-wrap" >
                <Table responsive>
                    <thead>
                        <tr>
                            {tableTitle?.map((title) => (
                                <th key={title} >
                                    {title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                    {isLoading ? (
                        [1, 2, 3, 4, 5, 6].map((val) => (
                            <tr key={val}>
                                {tableTitle?.map((index) =>
                                (<td key={index}>
                                    <Skeleton animation="wave" />
                                </td>)
                                )}
                            </tr>
                            ))
                    )
                    :filteredDocumentList?.length > 0 ? (
                    filteredDocumentList
                        ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        ?.map((data) => {
                            const { id, documentName, location, description, content} = data;
                            let url = content?.[0]?.attachment?.url
                            let title = content?.[0]?.attachment?.title
                            return (
                                <tr key={id}>
                                    <td>
                                        <div
                                            className="click-url"
                                            title={url}
                                            onClick={() =>  handleLinkOpen(url)}
                                        >
                                            {title || documentName}
                                        </div>
                                    </td>
                                    <td
                                        style={{
                                        wordBreak: "break-word",
                                        maxWidth: "200px",
                                        whiteSpace: "pre-wrap"
                                    }}
                                    >
                                        <Tooltip title={description.length > 70 ? description : ""} placement="top">
                                            <span>{truncateText(description, 70)}</span>
                                        </Tooltip>
                                    </td>
                                    <td style={{ wordBreak: "break-word", maxWidth: "200px", whiteSpace: "pre-wrap" }}>
                                        {location?.length > 0 ? (
                                            <div style={{ paddingLeft: "5px", margin: 0 }}>
                                                {location.map((item, index) => (
                                                    <>
                                                        <span
                                                            key={index}
                                                            onClick={() => handleViewLocation(item.reference.split("/")[1])}
                                                            title={"View Location"}
                                                            className="click-url"
                                                        >
                                                            {item.display}
                                                        </span>
                                                        {index < location.length - 1 && ", "}  {/* Add a comma separator */}
                                                    </>
                                                ))}
                                            </div>
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                </tr>
                            );
                        })
                        ) : (
                            <tr>
                                <TableCell
                                    colSpan={tableTitle.length}
                                    style={{ textAlign: "center" }}
                                >
                                    No Data Available
                                </TableCell>
                            </tr>
                        )}
                    </tbody>
                </Table>
                {filteredDocumentList?.length > 0 && (
                    <div>
                        <CustomPagination
                            tableData={filteredDocumentList}
                            totalRows={totalRows}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            handlePage={(pageNo) => setPage(pageNo)}
                        />
                    </div>
                )}
                </div>
              </div>
                
            </Modal.Body>
        </Modal>
        
        </>
        
    );
}